<div class="container">
  <ng-content></ng-content>
</div>
<app-footer></app-footer>
